import AuthActions from "./AuthActions";
import CounterpartiesActions from "./CounterpartiesActions";
import LeadsActions from "./LeadsActions";
import ProjectsActions from "./ProjectsActions";
import AttachmentsActions from "./AttachmentsActions";
import NotificationsActions from "./NotificationsActions";
import EventsActions from "./EventsActions";
import UsersActions from "./UsersActions";
import connector from "./connector";

class Repository {
  connector = connector;
  AuthActions = AuthActions;
  CounterpartiesActions = CounterpartiesActions;
  LeadsActions = LeadsActions;
  ProjectsActions = ProjectsActions;
  AttachmentsActions = AttachmentsActions;
  NotificationsActions = NotificationsActions;
  EventsActions = EventsActions;
  UsersActions = UsersActions
}

export default new Repository();
